import { render, staticRenderFns } from "./ReChannelPostAdd.vue?vue&type=template&id=c9697876&scoped=true"
import script from "./ReChannelPostAdd.vue?vue&type=script&lang=js"
export * from "./ReChannelPostAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9697876",
  null
  
)

export default component.exports